
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customcreatepercheckout_68e58815a5fe5912e60023aa } from '../../api/checkoutsdb.api'

import './shopcartinfo.scss';






const Pshopcartinfo = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  
  
  

  
  return (
    <div id="id68e6f4a18e5aed52dc7f1c23" >

      <div id="iw4j" className="">
      
      <div id="iwv3ah" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggu1zyt.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <div id="ijyg9l" className="">
      
      <div id="iowj1k" className="">
      
      <a
        target=""
        className=""
        id="il8xfg"
        href="/"
        type="button"
      >
        
    <div id="ihswfv" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iuicrj"
        href="/productos"
        type="button"
      >
        
    <div id="ih9i7g" className="">
    <>PRODUCTOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ib4wzs"
        href="/certificados"
        type="button"
      >
        
    <div id="ie4p6q" className="">
    <>CERTIFICACIONES</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="itj7od"
        href="/contacto"
        type="button"
      >
        
    <div id="i6b0kg" className="">
    <>CONTACTO</>
    </div>
    
      </a>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3dh" className="">
      
      <div id="ir0eig" className="">
      
      <div id="iy5oih" className="">
      
      <div id="i2sn9j" className="">
      
      <div id="ix39ka" className="">
      
      <div className="" id="ic5hru">
        <>Productos</>
      </div>
      
      <div className="" id="imp3tf">
        <>Precio</>
      </div>
      
      <div className="" id="i2hd9l">
        <>Cantidad</>
      </div>
      
      <div className="" id="ipmt0i">
        <>Opciones</>
      </div>
      
      </div>
      
      </div>
      
      <div id="it2qkm" className="">
      
        <div className="" id="iuj2zr">
          
      <form
        id="iid1p5"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await customcreatepercheckout_68e58815a5fe5912e60023aa({
						token: 'aasdas',
						namefield: e.target.namefield.value,
						phonenumber: e.target.phonenumber.value,
						cityparam: e.target.cityparam.value,
						undefined: e.target.undefined.value,
					});
					window.location.href = `/orden/${lofty_response?.data?._id}`;
		} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="ib999k" className="">
      
      <div className="" id="isas2w">
        <>Dirección de Envio</>
      </div>
      
      <div id="ivg67p" className="">
      
      </div>
      
      </div>
      
      <div id="ivhlib" className="">
      
      <label id="" className="">
      <>Nombre</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="namefield"
        type="text"
        placeholder="Nombre"
        className="inputformstyle "
        id="i4ds6j"
      />
      
      </div>
      
      <div id="ip9irm" className="">
      
      <label id="" className="">
      <>Telefono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="phonenumber"
        type="text"
        placeholder="No. Telefono"
        className="inputformstyle "
        id="i2rv87"
      />
      
      </div>
      
      <div id="iao7ek" className="">
      
      <label id="" className="">
      <>Ciudad</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="cityparam"
        type="text"
        placeholder="Ciudad"
        className="inputformstyle "
        id="iu7tds"
      />
      
      </div>
      
    <div id="ibwzcs" className="">
    
      <label id="" className="">
      <>Direccion Completa</>
      </label>
      
      <br className="" id="" />
      
      <textarea name="fulladdress" className="inputformstyle " id="i6fjao">
        
      </textarea>
      
    </div>
    
      <button
        type="submit"
        name=""
        id="imy0la"
        className=""
        
      >
      
      <div id="i6oasl" className="">
      <>Enviar por WhatsApp</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        <>Petrus Gems</>
      </div>
      
      <div className="" id="iygu8i">
        <>Elaboración de joyas de forma artesanal por mano de mujeres en nuestras comunidades</>
      </div>
      
      <div id="ix6pbo" className="">
      
        <a
          target=""
          className=""
          id="ibwuje"
          href="https://www.facebook.com/gemspetrus.hn"
        >
          
      <img
        className=""
        id="iy1qpk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiadxwc.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="iqvgxw"
          href="https://www.instagram.com/gemspetrus/"
        >
          
      <img
        className=""
        id="i26xh9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiafdkq.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Enlaces Rápidos</>
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/productos"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Productos</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/certificados"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>Certificados</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/contacto"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div id="iincid" className="">
      
      <span className="material-icons " id="iwlmju">
        
      <span className="material-icons " id="iz5z0g">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="i78qcc">
        <>+504 8895-1552</>
      </div>
      
      </div>
      
      <div id="idmnrv" className="">
      
      <span className="material-icons " id="i7tn5m">
        
      <span className="material-icons " id="isg8ci">
        
      <span className="material-icons " id="iuenok">
        <>mail</>
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="il1rnw">
        <>handalcarl13@gmail.com</>
      </div>
      
      </div>
      
      <div id="i2jt24" className="">
      
      <span className="material-icons " id="il9zag">
        
      <span className="material-icons " id="iom84k">
        
      <span className="material-icons " id="i1y0v4">
        
      <span className="material-icons " id="iwl57t">
        <>my_location</>
      </span>
      
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="i1at63">
        <>ubicacion</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pshopcartinfo);
  